import React, { useState, useEffect, useContext } from 'react'
import { useStyles } from './ObjetosCaso.styles'
import { Grid, Typography, Avatar } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import useRouter from 'utils/useRouter'
import moment from 'moment'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import FingerprintIcon from '@material-ui/icons/Fingerprint'
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned'
import PersonIcon from '@material-ui/icons/Person'
import LocationCityIcon from '@material-ui/icons/LocationCity'
import DriveEtaIcon from '@material-ui/icons/DriveEta'
import AssignmentIcon from '@material-ui/icons/Assignment'

import { useVestigioService } from 'hooks/useVestigioService'
import { useRequisicaoService } from 'hooks/useRequisicaoService'
import { useCadaverService } from 'hooks/useCadaverService'
import { usePericiandoService } from 'hooks/usePericiandoService'
import { useSolicitacaoExameService } from 'hooks/useSolicitacaoExameService'
import { useVeiculoService } from 'hooks/useVeiculoService'
import { useCasoService } from 'hooks/useCasoService'
import { useLocal } from 'hooks/useLocal'

import { CardCadaver } from 'components/Cards/CardCadaver'
import { CardVestigio } from 'components/Cards/CardVestigio'
import { CardPericiando } from 'components/Cards/CardPericiando'
import { CardLocal } from 'components/Cards/CardLocal'
import { CardVeiculo } from 'components/Cards/CardVeiculo'
import { CardSolicitacaoExame } from 'components/CardSolicitacaoExame'
import { CardRequisicao } from 'components/Cards/CardRequisicao'
import { ExibirArquivo } from 'components/ExibirArquivo'

import { DetalhesCasoContext } from '../../DetalhesCasoContext'

export const ObjetosCasoContainer = (props) => {
  const { textoVazio, children, viewMode } = props
  const dados = useContext(DetalhesCasoContext)
  if (!dados) return null
  const arrayChildren = React.Children.toArray(children)
  let total = 0
  arrayChildren.forEach((child) => {
    const tipoBusca = child.props?.tipo === 'local' ? 'endereco' : child.props?.tipo
    tipoBusca ? (dados.detalhes[tipoBusca] ? (total += dados.detalhes[tipoBusca]) : (total += 0)) : null
  })
  const classes = useStyles()

  if (total === 0) {
    return (
      <Grid container justifyContent="center" alignItems="center" style={{ padding: '50px' }}>
        <Typography>{textoVazio || 'Nenhum objeto associado ao caso'}</Typography>
      </Grid>
    )
  }

  return (
    <Grid item xs={12} style={{ width: '100%' }}>
      <div className={viewMode === 'list' ? classes.unifiedListWrapper : ''}>
        <Grid container direction={viewMode === 'list' ? 'column' : 'row'} alignItems="stretch" spacing={viewMode === 'list' ? 0 : 2} style={{ marginTop: viewMode === 'list' ? '0px' : '5px' }}>
          {children}
        </Grid>
      </div>
    </Grid>
  )
}

const getObjectFields = (tipo, objeto) => {
  switch (tipo) {
    case 'cadaver':
      return {
        titulo: 'CADÁVER',
        icon: <PersonOutlineIcon />,
        fields: [
          { label: 'NIC', value: objeto.nic || 'NÃO INFORMADO' },
          { label: 'Status', value: objeto.status || 'ATIVO' },
          { label: 'Data de Entrada', value: objeto.createdAt ? moment(objeto.createdAt).format('DD/MM/YYYY') : 'NÃO INFORMADA' },
        ],
        footerField: { label: 'Descrição Geral', value: objeto.descricaoGeral || 'SEM DESCRIÇÃO' },
      }
    case 'vestigio':
      return {
        titulo: objeto.contraprova ? 'VESTÍGIO (CONTRAPROVA)' : 'VESTÍGIO',
        icon: <FingerprintIcon />,
        fields: [
          { label: 'Identificador', value: objeto.identificador || 'NÃO INFORMADO' },
          { label: 'Lacre', value: objeto.lacre || 'NÃO INFORMADO' },
          { label: 'Status', value: objeto.statusCadeiaCustodia || 'ATIVO' },
          { label: 'Natureza (Gen.)', value: objeto.tiposGens?.map((t) => t.nome).join(', ') || 'NÃO INFORMADA' },
          { label: 'Natureza (Esp.)', value: objeto.tiposEsps?.map((t) => t.nome).join(', ') || 'NÃO INFORMADA' },
          { label: 'Data de Entrada', value: objeto.createdAt ? moment(objeto.createdAt).format('DD/MM/YYYY') : 'NÃO INFORMADA' },
        ],
        footerField: { label: 'Descrição', value: objeto.descricao || 'SEM DESCRIÇÃO' },
      }
    case 'requisicao':
      return {
        titulo: 'REQUISIÇÃO',
        icon: <AssignmentReturnedIcon />,
        fields: [
          { label: 'Identificador', value: objeto.identificador || 'NÃO INFORMADO' },
          { label: 'Documento', value: objeto.numeroDocumento || 'NÃO INFORMADO' },
          { label: 'Órgão de Origem', value: objeto.orgaoOrigem?.nome || 'NÃO INFORMADO' },
          { label: 'Status', value: objeto.status || 'ATIVO' },
          { label: 'Data de Entrada', value: objeto.createdAt ? moment(objeto.createdAt).format('DD/MM/YYYY') : 'NÃO INFORMADA' },
        ],
        footerField: { label: 'Descrição', value: objeto.descricao || 'SEM DESCRIÇÃO' },
      }
    case 'periciando':
      return {
        titulo: 'PERICIANDO',
        icon: <PersonIcon />,
        fields: [
          { label: 'Nome', value: objeto.nome?.toUpperCase() || 'NÃO INFORMADO' },
          { label: 'RG', value: objeto.rg || 'NÃO INFORMADO' },
          { label: 'Status', value: objeto.status || 'ATIVO' },
          { label: 'Data de Entrada', value: objeto.createdAt ? moment(objeto.createdAt).format('DD/MM/YYYY') : 'NÃO INFORMADA' },
        ],
        footerField: { label: 'Mãe', value: objeto.mae || 'NÃO INFORMADA' },
      }
    case 'local':
      return {
        titulo: 'LOCAL',
        icon: <LocationCityIcon />,
        fields: [
          { label: 'Descrição', value: objeto.descricaoObjeto || 'NÃO INFORMADA' },
          { label: 'Status', value: objeto.status || 'ATIVO' },
          { label: 'Data de Entrada', value: objeto.createdAt ? moment(objeto.createdAt).format('DD/MM/YYYY') : 'NÃO INFORMADA' },
        ],
        footerField: { label: 'Endereço', value: objeto.enderecoFormatado || objeto.pontoReferencia || 'NÃO INFORMADO' },
      }
    case 'veiculo':
      return {
        titulo: 'VEÍCULO',
        icon: <DriveEtaIcon />,
        fields: [
          { label: 'Placa', value: objeto.placa?.toUpperCase() || 'NÃO INFORMADA' },
          { label: 'Marca', value: objeto.marca || 'NÃO INFORMADA' },
          { label: 'Modelo', value: objeto.modelo || 'NÃO INFORMADO' },
          { label: 'Cor', value: objeto.cor || 'NÃO INFORMADA' },
          { label: 'Status', value: objeto.status || 'ATIVO' },
        ],
        footerField: { label: 'Data de Entrada', value: objeto.createdAt ? moment(objeto.createdAt).format('DD/MM/YYYY') : 'NÃO INFORMADA' },
      }
    default:
      return {
        titulo: 'OBJETO',
        icon: <AssignmentIcon />,
        fields: [{ label: 'ID', value: objeto.id }],
        footerField: null,
      }
  }
}

const RowObjeto = (props) => {
  const { tipo, objeto, handleClick } = props
  const classes = useStyles()
  const data = getObjectFields(tipo, objeto)

  // Separa os campos principais do rodapé
  let mainFields = [...data.fields]
  const footerField = data.footerField

  // Unifica as Naturezas no Vestígio em uma única coluna
  if (tipo === 'vestigio') {
    const genIdx = mainFields.findIndex((f) => f.label === 'Natureza (Gen.)')
    const espIdx = mainFields.findIndex((f) => f.label === 'Natureza (Esp.)')
    
    if (genIdx !== -1 || espIdx !== -1) {
      const genVal = genIdx !== -1 ? mainFields[genIdx].value : ''
      const espVal = espIdx !== -1 ? mainFields[espIdx].value : ''
      const cleanGen = genVal !== 'NÃO INFORMADA' ? genVal : ''
      const cleanEsp = espVal !== 'NÃO INFORMADA' ? espVal : ''
      
      let combinedVal = 'NÃO INFORMADA'
      if (cleanGen || cleanEsp) {
        combinedVal = [cleanGen, cleanEsp].filter(Boolean).join(' / ')
      }
      
      const fieldsFiltrados = mainFields.filter((f) => f.label !== 'Natureza (Gen.)' && f.label !== 'Natureza (Esp.)')
      const insertionIndex = genIdx !== -1 ? genIdx : 3
      fieldsFiltrados.splice(insertionIndex, 0, { label: 'Natureza', value: combinedVal })
      mainFields = fieldsFiltrados
    }
  }

  // Preenche os campos principais até ter exatamente 5 colunas
  while (mainFields.length < 5) {
    mainFields.push({ label: '', value: '', isPadding: true })
  }

  // Monta o array final com exatamente 6 posições: 5 colunas padrão + 1 coluna larga no final (footer)
  const finalGrid = [
    ...mainFields,
    footerField ? footerField : { label: '', value: '', isPadding: true }
  ]

  return (
    <div className={classes.rowRoot} onClick={() => handleClick(objeto.id)}>
      <Grid container alignItems="center" spacing={2} wrap="nowrap">
        <Grid item xs={2} style={{ display: 'flex', alignItems: 'center', minWidth: '160px' }}>
          <Avatar className={classes.rowAvatar}>{data.icon}</Avatar>
          <Typography className={classes.rowTypeTitle} variant="subtitle2">
            {data.titulo}
          </Typography>
        </Grid>
        <Grid item xs style={{ flexGrow: 1, overflow: 'hidden' }}>
          <Grid container spacing={2} wrap="nowrap" alignItems="center">
            {finalGrid.map((field, idx) => {
              const isLastColumn = idx === 5; // A sexta coluna (índice 5) sempre recebe a Descrição/Rodapé
              return (
                <Grid item xs style={{ flex: isLastColumn ? 2 : 1, minWidth: 0 }} key={idx}>
                  {!field.isPadding && (
                    <>
                      <Typography className={classes.rowFieldLabel} variant="caption">
                        {field.label}
                      </Typography>
                      <Typography className={classes.rowFieldValue} variant="body2">
                        {field.value || '---'}
                      </Typography>
                    </>
                  )}
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

const SkeletonObjetos = ({ viewMode, md = 3, sm = 9, xs = 12 }) => {
  const classes = useStyles()
  const skeletonCount = [1, 2, 3]

  if (viewMode === 'list') {
    return (
      <>
        {skeletonCount.map((i) => (
          <div key={i} className={classes.skeletonRow}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <Skeleton variant="circle" width={36} height={36} animation="wave" />
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" width="30%" height={20} animation="wave" />
                <Skeleton variant="text" width="60%" height={16} animation="wave" />
              </div>
            </div>
          </div>
        ))}
      </>
    )
  }

  return (
    <>
      {skeletonCount.map((i) => (
        <Grid key={i} item md={md} sm={sm} xs={xs} className={classes.objetoGridItem}>
          <Skeleton
            variant="rect"
            height={160}
            animation="wave"
            className={classes.skeletonCard}
          />
        </Grid>
      ))}
    </>
  )
}

export const ObjetosCaso = (props) => {
  const { tipo, viewMode, ...rest } = props
  const classes = useStyles()
  const router = useRouter()
  const context = useContext(DetalhesCasoContext)
  if (!context || !context.caso) return null
  const dados = context.caso
  const casoService = useCasoService()
  const vestigioService = useVestigioService()
  const requisicaoService = useRequisicaoService()
  const cadaverService = useCadaverService()
  const periciandoService = usePericiandoService()
  const veiculoService = useVeiculoService()
  const solicitacaoExameService = useSolicitacaoExameService()
  const localService = useLocal()
  const [objetos, setObjetos] = useState([])
  const [processando, setProcessando] = useState(false)

  const { md = 3, sm = 9, xs = 12 } = rest
  const cards = {
    vestigio: CardVestigio,
    requisicao: CardRequisicao,
    cadaver: CardCadaver,
    periciando: CardPericiando,
    local: CardLocal,
    veiculo: CardVeiculo,
    solicitacao: CardSolicitacaoExame,
    arquivo: ExibirArquivo,
  }
  const fetch = {
    vestigio: vestigioService.listarVestigiosDeCasoAsync,
    requisicao: requisicaoService.listarRequisicaoDeCasoAsync,
    cadaver: cadaverService.listarCadaveresDeCasoAsync,
    periciando: periciandoService.listarPericiandosDeCasoAsync,
    local: localService.listarLocaisDeCasoAsync,
    veiculo: veiculoService.listarVeiculosDeCasoAsync,
    solicitacao: solicitacaoExameService.listarSolicitacoesDeCasoAsync,
    arquivo: casoService.listarArquivos,
  }

  useEffect(() => {
    const fetchData = async () => {
      if (!dados || !dados.id) return
      const countKey = tipo === 'local' ? 'endereco' : tipo
      if (context?.detalhes && !context.detalhes[countKey]) {
        setObjetos([])
        return
      }
      const resultados = await fetch[tipo](dados.id, setProcessando)
      setObjetos(resultados)
    }
    fetchData()
  }, [tipo, dados?.id, context?.detalhes[tipo === 'local' ? 'endereco' : tipo]])

  const handleRowClick = (id, novaAba) => {
    if (tipo === 'requisicao') {
      handleRowClickRequisicao(id, novaAba)
      return
    }
    if (novaAba) {
      window.open(`/casos/caso/${tipo}/detalhar/${id}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/casos/caso/${tipo}/detalhar/${id}`)
    }
  }

  const handleRowClickRequisicao = (id, novaAba) => {
    if (novaAba) {
      window.open(`/requisicoes/requisicao/detalhar/${id}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/requisicoes/requisicao/detalhar/${id}`)
    }
  }

  if (processando && (!objetos || objetos.length === 0)) {
    return <SkeletonObjetos viewMode={viewMode} md={md} sm={sm} xs={xs} />
  }

  if (!objetos || objetos.length === 0) {
    return null
  }

  if (viewMode === 'list') {
    return (
      <>
        {objetos.map((objeto) => (
          <RowObjeto key={objeto.id} tipo={tipo} objeto={objeto} handleClick={handleRowClick} />
        ))}
      </>
    )
  }

  const gridProps = { md, sm, xs }

  return objetos.map((objeto) => (
    <Grid key={objeto.id} item {...gridProps} className={classes.objetoGridItem}>
      {React.createElement(cards[tipo], { [tipo]: objeto, handleClick: handleRowClick || null, idSolicitacaoExame: objeto.id || null, id: objeto.id || null, rotaLoadFile: '/arquivo/caso' })}
    </Grid>
  ))
}
